<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>明細表示形式：{{ reportLabel }}</div>
    <div>利用採用順：{{ adoptOrderLabel }}</div>
    <div>R定義：{{ repeat }}回以上</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    report: {
      type: String,
    },
    orderValue: {
      type: Number,
    },
    customerCountValue: {
      type: Number,
    },
    adoptOrder: {
      type: String,
    },
    repeat: {
      type: Number,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    reportLabel() {
      switch (this.report) {
        case 'all':
          return '全件表示'
        case 'order':
          return `採用順上位${this.orderValue}件`
        case 'customers':
          return `累計購買者数${this.customerCountValue}%`
      }
      return ''
    },
    adoptOrderLabel() {
      switch (this.adoptOrder) {
        case 'id_count':
          return 'ID数'
        case 'coefficient_id_count':
          return '加重平均ID数'
      }
      return ''
    },
  },
}
</script>
